import { DeployedTemplate } from "routes/createContent/api/catalogueDeployments";
import { humanize } from "./constants";

const INDENT = "  ";

const weeksText = (weeks: number[] | null): string => {
  if (!weeks || weeks.length === 0) return "all weeks";
  const sorted = [...weeks].sort((a, b) => a - b);
  const first = sorted[0];
  const last = sorted[sorted.length - 1];
  const contiguous = sorted.length === last - first + 1;
  return contiguous ? `weeks ${first}-${last}` : `weeks ${sorted.join(",")}`;
};

const daysText = (days: number[] | null): string =>
  !days || days.length === 0 ? "every day" : `days ${[...days].sort((a, b) => a - b).join(",")}`;

const localizedName = (name: Record<string, string> | null): string => {
  if (!name) return "(none)";
  return Object.keys(name)
    .sort()
    .map(locale => `${locale}: ${name[locale]}`)
    .join(" | ");
};

export const serializeSchedule = (schedule: DeployedTemplate): string => {
  const lines: string[] = [
    `template ${schedule.key}${schedule.retired ? " (deleted)" : ""}`,
    `${INDENT}name: ${localizedName(schedule.name)}`,
    `${INDENT}group: ${schedule.group_key ? humanize(schedule.group_key) : "(none)"}`,
    `${INDENT}questionnaire: ${humanize(schedule.health_form_type)}`,
    `${INDENT}exercises per day: ${schedule.exercises_per_day}`,
    `${INDENT}program length: ${schedule.duration_weeks ? `${schedule.duration_weeks} weeks` : "ongoing"}`,
    `${INDENT}functional test: ${schedule.includes_functional_test ? "yes" : "no"}`,
    "",
    `exercises (${schedule.exercises.length})`,
  ];

  for (const exercise of [...schedule.exercises].sort((a, b) => a.exercise_name.localeCompare(b.exercise_name))) {
    lines.push(`${INDENT}${exercise.exercise_name}`);
    lines.push(`${INDENT}${INDENT}${weeksText(exercise.weeks)}, ${daysText(exercise.days)}`);
    lines.push(
      `${INDENT}${INDENT}level ${exercise.recommended_level}${exercise.level_locked ? " (locked)" : ""}, ` +
        `${exercise.recommended_sets ?? "-"} sets, ${exercise.recommended_reps ?? "-"} reps` +
        `${exercise.pinned ? ", pinned" : ""}`
    );
  }

  lines.push("");
  lines.push(`lessons (${schedule.lessons.length})`);
  for (const lesson of [...schedule.lessons].sort((a, b) => a.position - b.position)) {
    lines.push(`${INDENT}${lesson.position}. ${lesson.lesson_name}`);
  }

  if (schedule.sustain_exercises.length > 0) {
    lines.push("");
    lines.push(`sustain exercises (${schedule.sustain_exercises.length})`);
    for (const exercise of [...schedule.sustain_exercises].sort((a, b) =>
      a.exercise_name.localeCompare(b.exercise_name)
    )) {
      lines.push(`${INDENT}${exercise.exercise_name}`);
    }
  }

  return lines.join("\n");
};
